import React from 'react';
import InstallmentItem from './InstallmentItem';
import { PaymentPlansLocalePath } from '../i18n/PaymentPlansLocale';
import { Tables } from '../../../../Components';
import { TableActions } from '../../../../Enums';
import { useTranslation } from 'react-i18next';
import { actionTypes, frequencyTypes } from '../constants';
import moment from 'moment';

function formatMonth(count) {
  const pluralRules = new Intl.PluralRules('en');
  const pluralForm = pluralRules.select(count);
  const suffix = pluralForm === 'one' ? 'month' : 'months';
  return suffix;
}

const InstallmentsDetails = ({ installments, dispatch }) => {
  const { t } = useTranslation(PaymentPlansLocalePath);
  const onActionClicked = (_enumKey, item) => {
    dispatch({
      value: item.id,
      action: actionTypes.REMOVE,
      nestedField: 'id',
      field: 'installment',
    });
  };
  return (
    <div className='p-3 flex gap-1 flex-col'>
      <InstallmentItem dispatch={dispatch} />
      <Tables
        parentTranslationPath={PaymentPlansLocalePath}
        headerData={[
          {
            label: 'installment %',
            input: 'amountPercentage',
            component: (row) => `${row.amountPercentage * 100}%`,
          },
          {
            label: 'trigger_type',
            input: 'frequencyId',
            component: (row) => {
              switch (row.frequencyName.toLowerCase()) {
                case frequencyTypes.MONTH:
                  return t('by_month');
                case frequencyTypes.DATE:
                  return t('by_fixed_date');
                case frequencyTypes.CONSTRUCTION_PROGRESS:
                  return t('completion');
                default:
                  return '';
              }
            },
          },
          {
            label: 'trigger_value',
            input: 'frequencyValue',
            component: (row) => {
              switch (row.frequencyName.toLowerCase()) {
                case frequencyTypes.MONTH:
                  return `${row.frequencyValue} ${t(
                    formatMonth(+row.frequencyValue)
                  )}`;
                case frequencyTypes.DATE:
                  return moment(row.frequencyValue).format('DD-MMM-YYYY');
                case frequencyTypes.CONSTRUCTION_PROGRESS:
                  return `${row.frequencyValue}% ${t('completion')}`;
                default:
                  return '';
              }
            },
          },

          { label: 'number_of_installment', input: 'numberOfInstallment' },
        ]}
        bodyRowId={'installment'}
        activePage={1}
        defaultActions={[{ enum: TableActions.delete.key }]}
        actionsOptions={{ onActionClicked }}
        data={installments}
        itemsPerPage={installments.length}
      />
    </div>
  );
};

export default InstallmentsDetails;
